export default __webpack_public_path__ + "static/media/hero-background.33294ba7.jpg";